/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from "react";
import { GlobalLogger, LogLevel } from "./debugLogger";
import { CameraPermissionModalConfig } from "./permissionModal";
import { WebToMobileHandOffConfig } from "./webToMobileModal";

export type GlobalContent = {
  logging: LogLevel;
  modelState: any;
  scanDebugState: any;
  threshold: any;
  setThreshold: any;
  laplacianThreshold: any;
  setLaplacianThreshold: any;
  scanFreqency: any;
  setScanFreqency: any;
  bufferSize: any;
  setBufferSize: any;
  bufferRef: any;
  debugCanvasBestRef: any;
  bestScore: any;
  bestLaplacian: any;
  debugCanvasLatestRef: any;
  latestScore: any;
  latestLaplacian: any;
  debugMenu: boolean;
  videoMetadata: any;
  showCurtain: boolean;
  onCloseBtn: any;
  closeButton: any;
  isMobile: boolean;
  isMobileOnLandscape: boolean;
  stateMachineState: any;
  stateMachineSend: any;
  stateMachineService: any;
  handleRetryButton: () => void;
  showErrorModal: boolean;
  cameraPermissionModalConfig?: CameraPermissionModalConfig;
  webToMobileHandoffConfig?: WebToMobileHandOffConfig;
  webviewVersion?: string | null;
  mobileSdkVersion?: string | null;
};

export const MyGlobalContext = createContext<GlobalContent>({
  logging: GlobalLogger.startingLogLevel,
  modelState: {},
  scanDebugState: {},
  threshold: {},
  setThreshold: {},
  laplacianThreshold: {},
  setLaplacianThreshold: {},
  scanFreqency: {},
  setScanFreqency: {},
  bufferSize: {},
  setBufferSize: {},
  bufferRef: {},
  debugCanvasBestRef: {},
  bestScore: {},
  bestLaplacian: {},
  debugCanvasLatestRef: {},
  latestScore: {},
  latestLaplacian: {},
  debugMenu: false,
  videoMetadata: {},
  showCurtain: false,
  onCloseBtn: () => {},
  closeButton: null,
  isMobile: false,
  isMobileOnLandscape: false,
  stateMachineState: {},
  stateMachineSend: () => {},
  stateMachineService: {},
  handleRetryButton: () => {},
  showErrorModal: false,
  cameraPermissionModalConfig: {},
  webToMobileHandoffConfig: {},
  webviewVersion: null,
  mobileSdkVersion: null,
});

export const useGlobalContext = () => useContext(MyGlobalContext);
